<template>
  <div :class="['menu-list', env.isBankabc ? 'bankabc' : '']" @touchmove="preventEvent">
    <div class="content" role="menu">
      <div
        role="menuitem"
        tabindex="0"
        @click="jumpHome"
        class="list-item"
        v-track="trackData.menuClick({ sku_id: skuId, titlebar_content: 1 })"
      >
        <em class="icon homepage"></em>
        <span>首页</span>
      </div>
      <div
        tabindex="0"
        role="menuitem"
        @click="refresh"
        class="list-item"
        v-track="trackData.menuClick({ sku_id: skuId, titlebar_content: 8 })"
      >
        <em class="icon refresh"></em>
        <span>刷新</span>
      </div>
      <div
        tabindex="0"
        role="menuitem"
        class="list-item"
        v-track="trackData.menuClick({ sku_id: skuId, titlebar_content: 2 })"
        @click="jump(`${linkBase}/my/favorite`)"
      >
        <em class="icon favorites"></em>
        <span>我的收藏</span>
      </div>
      <template v-if="isHeader">
        <div
          tabindex="0"
          role="menuitem"
          path="/my/order"
          class="list-item"
          v-track="trackData.menuClick({ sku_id: skuId, titlebar_content: 3 })"
          @click="jump(`${linkBase}/my/order`)"
        >
          <em class="icon orders"></em>
          <span>我的订单</span>
        </div>
        <div
          tabindex="0"
          role="menuitem"
          @click="showHistory"
          class="list-item"
          v-track="trackData.menuClick({ sku_id: skuId, titlebar_content: 4, taskType: 1 })"
        >
          <em class="icon history"></em>
          <span>浏览记录</span>
        </div>
        <div
          tabindex="0"
          role="menuitem"
          v-if="showSug"
          @click="deeplinkSug"
          class="list-item"
          v-track="trackData.menuClick({ sku_id: skuId, titlebar_content: 5 })"
        >
          <em class="icon suggestion"></em>
          <span>意见反馈</span>
        </div>
      </template>
      <template v-else>
        <OutLink
          tabindex="0"
          role="menuitem"
          path="/my"
          class="list-item"
          v-track="trackData.menuClick({ sku_id: skuId, titlebar_content: 6 })"
        >
          <em class="icon center"></em>
          <span>个人中心</span>
        </OutLink>
        <OutLink
          tabindex="0"
          role="menuitem"
          path="/category"
          class="list-item"
          v-if="!env.isIOSVivoApp"
          v-track="trackData.menuClick({ sku_id: skuId, titlebar_content: 7 })"
        >
          <em class="icon category"></em>
          <span>全部分类</span>
        </OutLink>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import env from '@/utils/clientEnv'
import { OutLink } from '@/components'
import app from '@/utils/app'
import { jumpToHome } from '@/utils/common'
// 埋点数据
import trackData from './trackData'
export default {
  name: 'MenuList',
  components: {
    OutLink
  },
  props: {
    // 是否为头部的汉堡菜单
    isHeader: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('detailv3', ['skuId'])
  },
  data() {
    return {
      showSug: env.isDefaultHideTitle,
      env,
      trackData
    }
  },
  methods: {
    showHistory() {
      this.$emit('showHistory')
    },
    // 跳转意见反馈
    deeplinkSug() {
      app.openAppByDeepLink({
        deepLink: 'space://vivo.com/faqhome'
      })
    },
    preventEvent(e) {
      e.preventDefault()
      e.stopPropagation()
    },
    refresh() {
      location.reload()
    },
    jump(url) {
      app.openNewWebview({ url: url })
    },
    async jumpHome() {
      jumpToHome()
    }
  }
}
</script>

<style lang="scss">
.vp-header-show-app {
  .menu-list {
    top: 285px !important;
    &::after {
      top: 307px !important;
    }
  }
}
</style>

<style lang="scss" scoped src="./index.scss"></style>
